import { PamtokenService } from "./core/services/pamtoken.service";
import { NgModule } from "@angular/core";
import { Routes, RouterModule, PreloadAllModules } from "@angular/router";
import {
  EmailVerifyComponent,
  SupportPageComponent,
  TermsAndConditionsComponent,
  EnrollComponent,
  BlockedComponent,
  RedeemPointsComponent,
  OpenHouseQuizComponent,
} from "./shared";
import { MaintenanceComponent } from "./shared/components/maintenance/maintenance.component";
import { AuthGuard, MaintainanceGaurd, CanAccessHomeModule } from "./core";
import { QuizComponent } from "./shared/components/quiz/quiz.component";
import { WelcomepageComponent } from "./home/welcomepage/welcomepage.component";
import { WinnerspageComponent } from "./winnerspage/winnerspage.component";
import { UserAccessValidationComponent } from "./shared/components/user-access-validation/user-access-validation/user-access-validation.component";
import { ApproverComponent } from "./approver/approver.component";
import { CallbackComponent } from "./auth/callback.component";
import { ComingSoonComponent } from "./coming-soon/coming-soon.component";

const routes: Routes = [
  // {
  //   path: '',
  //   loadChildren: './login/login.module#LoginModule',
  //   canActivate: [MaintainanceGaurd]
  // },
  {
    path: "callback",
    component: CallbackComponent,
  },
  {
    path: "enroll",
    component: EnrollComponent,
    canActivate: [MaintainanceGaurd],
  },
  {
    path: "blocked",
    component: BlockedComponent,
    canActivate: [MaintainanceGaurd],
  },
  {
    path: "redeem-points",
    component: RedeemPointsComponent,
    canActivate: [MaintainanceGaurd],
  },
  {
    path: "email/:type/:token",
    component: EmailVerifyComponent,
    canActivate: [MaintainanceGaurd],
  },
  {
    path: "role/:type/:token",
    component: EmailVerifyComponent,
    canActivate: [MaintainanceGaurd],
  },
  {
    path: "sca/:status/:verification-token",
    component: EmailVerifyComponent,
    canActivate: [MaintainanceGaurd],
  },
  {
    path: "emails/unsubscribe/:notificationTypeId",
    component: EmailVerifyComponent,
    canActivate: [MaintainanceGaurd],
  },
  {
    path: "support",
    component: SupportPageComponent,
    canActivate: [MaintainanceGaurd],
  },
  {
    path: "open-house-quiz",
    component: OpenHouseQuizComponent,
    canActivate: [MaintainanceGaurd],
  },

  {
    path: "seller-rewards-quiz/:id",
    component: QuizComponent,
    canActivate: [MaintainanceGaurd],
  },
  {
    path: "seller-rewards-quiz",
    component: QuizComponent,
    canActivate: [MaintainanceGaurd],
  },
  {
    path: "maintenance",
    component: MaintenanceComponent,
  },
  {
    path: "termsandconditions",
    component: TermsAndConditionsComponent,
    canActivate: [MaintainanceGaurd],
  },
  {
    path: "profile",
    loadChildren: "./profile/profile.module#ProfileModule",
    canActivate: [MaintainanceGaurd, AuthGuard],
  },
  {
    path: "home",
    loadChildren: "./home/home.module#HomeModule",
    canActivate: [MaintainanceGaurd, AuthGuard, CanAccessHomeModule],
  },
  {
    path: "welcome",
    loadChildren: "./home/welcomepage/welcomepage.module#WelcomepageModule",
    canActivate: [MaintainanceGaurd, AuthGuard],
  },
  {
    path: "winnersPage",
    component: WinnerspageComponent,
    canActivate: [MaintainanceGaurd],
  },
  {
    path: "user-access-validation",
    component: UserAccessValidationComponent,
    canActivate: [MaintainanceGaurd],
  },
  {
    path: "approver",
    component: ApproverComponent,
    canActivate: [MaintainanceGaurd],
  },

  {
    path: "**",
    redirectTo: "",
    pathMatch: "full",
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
  ],
  exports: [RouterModule],
  providers: [AuthGuard, MaintainanceGaurd, CanAccessHomeModule],
})
export class AppRoutingModule {}
